import { ArrowDownIcon, ArrowUpIcon } from "cssReset/icon";
import { getChangeRateLabel } from "utils/dashboard.util";

const renderComparisonBox = (current: number, previous: number) => {
  const { label, isIncrease, isEqual } = getChangeRateLabel(current, previous);

  return (
    <div
      className={`comparison-box ${
        isEqual ? "equal" : isIncrease ? "increase" : "decrease"
      }`}
    >
      {!isEqual && (
        <span className="icon">
          {isIncrease ? <ArrowUpIcon /> : <ArrowDownIcon />}
        </span>
      )}
      <span className="rate">{label}</span>
    </div>
  );
};

export default renderComparisonBox;
